// 切换device
export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'

// 面包屑相关
export const BREADLISTADD = 'BREADLISTADD'
export const BREADLISTREMOVE = 'BREADLISTREMOVE'
export const BREADLISTSET = 'BREADLISTSET'

export const USERINFO_UPDATE = 'USERINFO_UPDATE'
export const USERINFO_REMOVE = 'USERINFO_REMOVE'
// 资源相关
export const RESOURCE_UPDATE = 'RESOURCE_UPDATE'
export const RESOURCE_REMOVE = 'RESOURCE_REMOVE'

//主题相关
export const THEME_UPDATE = 'THEME_UPDATE'

// 是否解码
export const DECODE_UPDATE = 'DECODE_UPDATE'

// 新内容提示
export const NEW_CONTENT_ALERT = 'NEW_CONTENT_ALERT'
